module.exports = __webpack_public_path__ + "static/media/linkedin.4b475fb3.svg";